// ante-react-kit/src/components/v2/hooks/useVoucherPrint.js
import { useRef, useCallback } from 'react';
import { useReactToPrint } from 'react-to-print';

export default function useVoucherPrint(opts) {
    // opts: { printerRef, printComponentRef, printUrl, API, postActionFn, paramsRef }
    var optsRef = useRef(opts);
    optsRef.current = opts;

    var handlePrint = useReactToPrint({
        content: function getPrintContent() {
            var o = optsRef.current;
            if (o.printComponentRef && o.printComponentRef.current) {
                return o.printComponentRef.current;
            }
            if (o.printerRef && o.printerRef.current) {
                return o.printerRef.current;
            }
            return null;
        }
    });

    var runPrint = useCallback(async function runPrint(strTemplate, options = {}) {
        var o = optsRef.current;
        try {
            var preparedPrinter = (o.printComponentRef && o.printComponentRef.current) || (o.printerRef && o.printerRef.current);
            if (options.preparedData?.html && preparedPrinter && typeof preparedPrinter.load === 'function') {
                await preparedPrinter.load(options.preparedData);
                return true;
            }
            if (o.printComponentRef && o.printComponentRef.current && typeof o.printComponentRef.current.load === 'function') {
                // Custom print component — load data via postAction('print')
                var data = await o.postActionFn('print');
                if (data) await o.printComponentRef.current.load(data);
            } else if (o.printUrl && o.API) {
                if (o.service === 'AROrder') {
                    var delivery = await o.API.postAsync('/ar/AROrder/remotePrint', {
                        code: (o.paramsRef?.current || {})?.code,
                        id: (o.paramsRef?.current || {})?.id,
                        template: typeof strTemplate === 'string' ? strTemplate : undefined
                    });
                    var deliveryData = delivery && delivery.data ? delivery.data : delivery;
                    if (deliveryData?.dispatched === true) return true;
                    if (deliveryData?.print_data?.html) {
                        if (o.printerRef && o.printerRef.current && o.printerRef.current.load) await o.printerRef.current.load(deliveryData.print_data);
                        return true;
                    }
                    // The delivery API owns fallback. Never bypass its error or
                    // permission result with a second generateBillHTML request.
                    return false;
                }
                // Server-generated HTML — fetch + load into AntPrinting
                var params = o.paramsRef ? o.paramsRef.current : {};
                var body = {
                    code: params.code || undefined,
                    id: params.id || undefined,
                    template: strTemplate
                };

                var result = await o.API.postAsync(o.printUrl, body);
                if (result && !result.error && result.data && o.printerRef && o.printerRef.current && o.printerRef.current.load) {
                    o.printerRef.current.load(result.data);
                }
            }
        } catch (e) {
            console.error('[useVoucherPrint] runPrint error:', e);
        }
    }, []);

    var onPrintReady = useCallback(function onPrintReady() {
        // AntPrinting.onReady → trigger browser print
        if (handlePrint) handlePrint();
    }, [handlePrint]);

    return { runPrint: runPrint, onPrintReady: onPrintReady };
}
